// extracted by mini-css-extract-plugin
module.exports = {"container":"_3BECVrLwCum0P0s-PpC6Zb"};